import React, { useEffect, useState, useRef } from "react";
import EventDetailList from "./EventDetailList";
import ImportSchedule from "./ImportSchedule";
import AddRoutine from "./AddRoutine";
// import { ThreeDots } from "../../../images/Svgs";
import {
  getAllEventsDetail,
  deleteRoutine,
  getEditRoutine,
  updateLogistics,
} from "../../../API/routine";
import { useParams } from "react-router-dom";
import { formatAMPM, formatDate } from "../../../utils/common";
import NoData from "../../../components/NoData";
import AddMessage from "./AddMessage";
import CommonDelete from "../../../utils/CommonDelet";
import { toast } from "react-toastify";
import RoutineDetail from "./RoutineDetail";
import { Base_Url } from "../../../API/config";
const EventDetail = () => {
  const [isImport, setIsImport] = useState(false);
  const [isAddRoutine, setIsAddRoutine] = useState(false);
  const [isAddMessage, setIstAddMessage] = useState(false);
  const [routineDetail, setRoutineDetail] = useState(false);
  const [editRoutine, setEditRoutine] = useState({});
  const [AllRoutine, setAllRoutine] = useState();
  const [deleteRoutineId, setDeleteRoutineId] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  const EventId = useParams();
  const fetchEditRoutine = async (id) => {
    const data = await getEditRoutine(id);
    setEditRoutine(data?.data);
  };

  const handleDetailRoutine = (id) => {
    fetchEditRoutine(id);
    setRoutineDetail(true);
  };
  // funciton for routine edit
  const handleEditRoutine = (id) => {
    fetchEditRoutine(id);
    setIsAddRoutine(true);
  };
  // funciton for routine add
  const addNewRoutineToggal = () => {
    setIsAddRoutine(!isAddRoutine);
    setEditRoutine({});
  };

  const eventSourceRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const isFetching = useRef(false);

  const fetchEventDetailsOnce = async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    try {
      const res = await fetch(
        `${Base_Url}/api/event-details?event_id=${EventId?.id}&status=&stream=1`
      );
      const result = await res.json();
      if (Array.isArray(result?.data)) {
        setAllRoutine(result.data); // ✅ Set only if it's an array
      } else {
        console.warn("Expected array from API, got:", result?.data);
        setAllRoutine([]); // Fallback to empty array
      }
    } catch (err) {
      console.error("Failed to fetch event details:", err);
    } finally {
      isFetching.current = false;
    }
  };

  const call_sse_data = () => {
    // Close any existing EventSource
    if (eventSourceRef.current) {
      console.log("SSE already running");
      return;
    }

    const url = `${Base_Url}/api/event-details?event_id=${EventId?.id}&status=&stream=1`;
    const eventSource = new EventSource(url);
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setAllRoutine((prev) => {
        const newData = JSON.stringify(data.data);
        const prevData = JSON.stringify(prev);
        return newData !== prevData ? data.data : prev;
      });
    };
    eventSource.onerror = (err) => {
      console.error('SSE Error:', err);
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      restartSSEWithDelay(); // only restart if it fails
    };
    // Store the EventSource so we can close it later
    eventSourceRef.current = eventSource;
  }

  // Throttle SSE restart
  const restartSSEWithDelay = () => {
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
    }
    reconnectTimeoutRef.current = setTimeout(() => {
      console.log("Restarting SSE after delay");
      call_sse_data();
    }, 1000);
  };


  useEffect(() => {
    if (!isAddRoutine && EventId?.id) {
      call_sse_data();
    }
    // Cleanup on component unmount
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
    };
  }, [EventId?.id, isAddRoutine]);

  const handleDeleteSubmit = async () => {
    try {
      const response = await deleteRoutine(deleteRoutineId);
      if (response?.status) {
        toast.success(response.message);
        call_sse_data();
        setDeleteRoutineId("");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error);
    }
  };
  const handleDeleteRoutine = async (id) => {
    setDeleteRoutineId(id);
  };
  const handleLogisticsChange = async (data) => {
    try {
      const response = await updateLogistics(data);
      if (response?.status) {
        toast.success(response.message || "success !");
        // Optimistic update
        setAllRoutine((prev) => {
          if (!Array.isArray(prev.eventSchedule)) return prev;
          const updatedSchedule = prev.eventSchedule.map((item) =>
            item.id == data.id ? { ...item, ...data } : item
          );
          const updated = { ...prev, eventSchedule: updatedSchedule };
          return updated;
        });
        await fetchEventDetailsOnce();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error);
    }
  };

  return (
    <div className="event_list_container">
      <div className="event_logistic_header">
        <div className="event_header">
          <div className="title">Event Details</div>
        </div>
      </div>
      <div className="event_list">
        <div className="event_logistics_event">
          <div className="event_details">
            <span>Event Name : </span>
            {AllRoutine?.event_title?.charAt(0)?.toUpperCase() + AllRoutine?.event_title.slice(1).toLowerCase()}
          </div>
          <div className="event_details">
            <span>Start Date : </span>
            {formatDate(AllRoutine?.event_date)}
          </div>
          <div className="event_details ">
            <span>End Date : </span>
            {formatDate(AllRoutine?.event_end_date)}
          </div>
          <div className="event_details">
            <span>Time : </span>
            {formatAMPM(AllRoutine?.event_time_from)}
          </div>
          <div className="event_details ">
            <span>Location : </span>
            {AllRoutine?.event_location}
          </div>
        </div>
      </div>
      <div className="event_logistics_header">
        <div className="title">Event Schedule </div>
        <div className="button_div">
          <div className="event_button">
            <button className="event_btn" onClick={() => setIsImport(true)}>
              Import Schedule
            </button>
          </div>
          <div className="event_button">
            <button className="event_btn" onClick={() => addNewRoutineToggal()}>
              Add Routine
            </button>
          </div>
          <div className="event_button">
            <button
              className="event_btn"
              onClick={() => {
                setIstAddMessage(true);
                setShowMessage(false);
              }}
            >
              Add Message
            </button>
          </div>
        </div>
      </div>
      <div className="event_logistics routin_detail_css">
        {AllRoutine?.eventSchedule && AllRoutine?.eventSchedule?.length > 0 ? (
          <EventDetailList
            handleEditRoutine={handleEditRoutine}
            routingList={AllRoutine?.eventSchedule}
            handleDeleteRoutine={handleDeleteRoutine}
            handleDetailRoutine={handleDetailRoutine}
            handleLogisticsChange={handleLogisticsChange}
            eventId={EventId?.id}
            fetchRoutine={call_sse_data}
          />
        ) : (
          <NoData title="There is no event schedule yet" />
        )}
      </div>
      {isImport && (
        <ImportSchedule
          onModalClose={setIsImport}
          EventId={EventId?.id}
          fetchRoutine={call_sse_data}
        />
      )}
      {isAddRoutine && (
        <AddRoutine
          onSetModal={setIsAddRoutine}
          editRoutine={editRoutine}
          eventList={AllRoutine}
        />
      )}
      {isAddMessage && (
        <AddMessage onSetModal={setIstAddMessage} EventId={EventId?.id} />
      )}
      {deleteRoutineId && (
        <CommonDelete
          onModalClose={setDeleteRoutineId}
          onSubmit={handleDeleteSubmit}
          title={"routine"}
        />
      )}
      {routineDetail && (
        <RoutineDetail
          openDetailModal={setRoutineDetail}
          RoutineDetail={editRoutine}
          EventDetail={AllRoutine}
        />
      )}
    </div>
  );
};
export default EventDetail;
